import { createSlice } from '@reduxjs/toolkit'

export const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    value: false,
  },
  reducers: {
    setAdmin: (state,action) => {
      state.value = true
    },
    clearAdmin: (state,action) => {
      state.value = false
    },
  },
})

export const { setAdmin,clearAdmin} = adminSlice.actions

export default adminSlice.reducer